import { useState, useCallback } from 'react';
import { ChangeEvent } from 'react';
export interface IValue {
  [key: string]: boolean;
}
export interface CheckboxStateValue extends IValue {};
export interface CheckboxState {
  [key: string]: boolean;
}
export type TSetCheckboxState = React.Dispatch<React.SetStateAction<IValue>>;
export type SetCheckboxState = TSetCheckboxState;
export type TChangeCheckbox = (event: ChangeEvent<Element>, isChecked: boolean) => void;
export type OnChangeCheckboxState = TChangeCheckbox;
export type TResult = [IValue, TChangeCheckbox, TSetCheckboxState];

type TUseCheckboxState = (initValue?: IValue) => TResult;

export const useCheckboxState: TUseCheckboxState = (initValue) => {
  const [value, setValue] = useState<IValue>(() => (initValue || {}));

  const onChangeValue = useCallback((event: any, isChecked: boolean) => {
    const key = event.target.value;
    setValue((state) => {
      const { [key]: keyValue, ...partState } = state;
      return { ...partState, ...isChecked && { [key]: true } };
    });
  }, [setValue]);

  return [value, onChangeValue, setValue];
};

export default useCheckboxState;
